import { MOBILE_NUMBER, USER_PROFILE } from "../Utils";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { getFileByPath, getFileServerAuthenticationCode } from "./URLCONSTANTS";
export async function GetApiHeaders() {
    var mobileNumber, userId = "";
    var details = sessionStorage.getItem(USER_PROFILE);
    if (details != "" && details != undefined && details != null) {
        var userDetails = JSON.parse(details);
        mobileNumber = userDetails.mobileNumber;
        userId = userDetails.userId;
        console.log("GetApiHeaders", mobileNumber, userId);
    }

    var headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        "userId": userId.toString(),
        'mobileNumber': mobileNumber,
    };
    console.log(headers)
    return headers;
}


let fileServerAuthCode = null;
let fileServerAuthCodePromise = null;
export async function GetApiHeadersWithToken() {
    try {
        // Already available
        if (fileServerAuthCode) {
            return fileServerAuthCode;
        }

        // Authentication API already in progress
        if (fileServerAuthCodePromise) {
            return await fileServerAuthCodePromise;
        }

        // Start authentication API only once
        fileServerAuthCodePromise = (async () => {
            const headers = await GetApiHeaders();

            console.log(
                "GetApiHeaders response:",
                headers
            );

            const response = await axios.get(
                getFileServerAuthenticationCode,
                { headers }
            );

            console.log(
                "getFileServerAuthenticationCode response:",
                response.data
            );

            if (
                response.data?.statusCode === "200" &&
                response.data?.response
            ) {
                const authCode = response.data.response;

                console.log(
                    "File Server Auth Code:",
                    authCode
                );

                // Store the actual value
                fileServerAuthCode = authCode;

                return authCode;
            }

            throw new Error(
                "Authentication code not received"
            );
        })();

        try {
            return await fileServerAuthCodePromise;
        } finally {
            // Clear only the Promise.
            // Keep fileServerAuthCode for reuse.
            fileServerAuthCodePromise = null;
        }
    } catch (error) {
        console.error(
            "Error fetching File Server Authentication Code:",
            error
        );

        throw error;
    }
}


const imageCache = new Map();
const imagePromiseCache = new Map();

export async function GetMediaImageUrl(getFileByPath, imagePath) {
    try {
        if (!imagePath || imagePath.trim() === "") {
            return "";
        }

        const cleanPath = imagePath.trim();

        // Image already loaded
        if (imageCache.has(cleanPath)) {
            return imageCache.get(cleanPath);
        }

        // Same image request is already in progress
        if (imagePromiseCache.has(cleanPath)) {
            return await imagePromiseCache.get(cleanPath);
        }

        const requestPromise = (async () => {
            const fileServerAuthCode =
                await GetApiHeadersWithToken();

            const imageUrl =
                `${getFileByPath}?imagePath=${encodeURIComponent(cleanPath)}`;

            const response = await axios.get(imageUrl, {
                headers: {
                    fileServerAuthCode: fileServerAuthCode,
                },
                responseType: "blob",
            });

            if (!response.data || response.data.size === 0) {
                return "";
            }

            const blobUrl = URL.createObjectURL(response.data);

            // Save loaded image
            imageCache.set(cleanPath, blobUrl);

            return blobUrl;
        })();

        // Save request while it is loading
        imagePromiseCache.set(cleanPath, requestPromise);

        try {
            return await requestPromise;
        } finally {
            imagePromiseCache.delete(cleanPath);
        }

    } catch (error) {
        console.error("Error loading media image:", error);
        return "";
    }
}



export async function GetMediaImageBlobUrl(imageUrl) {
    try {
        if (!imageUrl) {
            return "";
        }

        const fileServerAuthCode =
            await GetApiHeadersWithToken();

        const response = await axios.get(imageUrl, {
            headers: {
                fileServerAuthCode: fileServerAuthCode,
            },
            responseType: "blob",
        });

        if (!response.data || response.data.size === 0) {
            return "";
        }

        return URL.createObjectURL(response.data);
    } catch (error) {
        console.error(
            "Error loading media image:",
            error
        );

        return "";
    }
}

export const ProtectedImage = ({ imagePath, onClick, }) => {
    const [imageUrl, setImageUrl] = useState("");
    useEffect(() => {
        let blobUrl = "";
        const loadImage = async () => {
            if (!imagePath) return;
            try {
                let url;
                // If complete Media API URL is received
                if (imagePath.startsWith("http")) {
                    url = await GetMediaImageBlobUrl(imagePath);
                }
                // If only image path is received
                else {
                    url = await GetMediaImageUrl(
                        getFileByPath,
                        imagePath
                    );
                }

                if (url) {
                    blobUrl = url;
                    setImageUrl(url);
                }
            } catch (error) {
                console.error("Error loading image:", error);
            }
        };

        loadImage();
        return () => {
            if (blobUrl) {
                URL.revokeObjectURL(blobUrl);
            }
        };
    }, [imagePath]);

    if (!imageUrl) {
        return null;
    }

    return (
        <img
            src={imageUrl}
            style={{
                width: "30px",
                height: "40px",
                cursor: "pointer",
                border: "1px solid black",
                objectFit: "cover",
            }}
            onClick={onClick}
        />
    );
};